module.exports = __webpack_public_path__ + "img/person3.4e710b6e.webp";